import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import DwebSavedPayments from './DwebSavedPayments';
import DwebSavedPaymentsContext from './context';
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

const SHOW_SAVED_PAYMENTS = 'showSavedPayments';

interface IDwebSavedPaymentsProviderProps {
  children: React.ReactNode;
}

function DwebSavedPaymentsProvider({ children }: IDwebSavedPaymentsProviderProps) {
  const [canShowSavedPayments, setShowSavedPayments] = useState(false);
  const { pathname, search } = useLocation();
  const history = useHistory();
  const { dweb: isSavedPaymentsEnabledOnDweb = false } = useRemoteConfig('savePaymentMethod');

  const showSavedPayments = useCallback(() => {
    const params = new URLSearchParams(search);
    params.set(SHOW_SAVED_PAYMENTS, '1');
    history.push(pathname + '?' + params.toString());
  }, [history, pathname, search]);

  const onHide = useCallback(() => {
    const params = new URLSearchParams(search);
    params.delete(SHOW_SAVED_PAYMENTS);
    history.replace(pathname + '?' + params.toString());
  }, [history, pathname, search]);

  useEffect(() => {
    const params = new URLSearchParams(search);
    setShowSavedPayments(params.get(SHOW_SAVED_PAYMENTS) === '1' && isSavedPaymentsEnabledOnDweb);
  }, [isSavedPaymentsEnabledOnDweb, search]);

  const values = useMemo(
    () => ({ showSavedPayments, canShowSavedPayments }),
    [canShowSavedPayments, showSavedPayments]
  );

  return (
    <DwebSavedPaymentsContext.Provider value={values}>
      {children}
      {canShowSavedPayments && <DwebSavedPayments onHide={onHide} />}
    </DwebSavedPaymentsContext.Provider>
  );
}

export default memo(DwebSavedPaymentsProvider);
